import createAction from './';

export const REMOVE_TOAST = createAction('REMOVE_TOAST');

/**
 * [removeToast]
 *
 * @param  {string} id of that toast message that need to be deleted
 * @return {Object}
 */
export function removeToast(id) {
  return {
    type: REMOVE_TOAST,
    payload: { id },
  };
}
